import React, { Component } from "react";
import { connect } from "react-redux";
import { signout } from "../../actions/auth.js";

import Row from "../../common/grid/Row";
import Col from "../../common/grid/Col";
import Button from "../../common/button/Button";
import NavLink from "./NavLink";
import RenderIfUserHas from "../../common/roles/RenderIfUserHas.js";
import PlaceholderThumb from "../../common/thumb/PlaceholderThumb";

import FaTask from "react-icons/lib/fa/tasks";
import FaUser from "react-icons/lib/fa/user";
import FaGroup from "react-icons/lib/fa/group";
import FaCalendar from "react-icons/lib/fa/calendar";
import FaBlackTie from "react-icons/lib/fa/black-tie";
import FaFolderOpen from "react-icons/lib/fa/folder-open";
import FaFileText from "react-icons/lib/fa/file-text";
import FaClockO from "react-icons/lib/fa/clock-o";
import FaFileO from "react-icons/lib/fa/file-o";

import "./SideBar.css";

class SideBar extends Component {
	onSignOutClick = () => {
		this.props.signout();
	};

	render() {
		const { user, match } = this.props;
		if (!user) {
			return <div>Loading...</div>;
		}

		return (
			<Col _no-grow side-bar>
				<Row _no-grow-first _no-align>
					<div className="left-placeholder" />
					<Col _bottom-16 _align-middle user-info>
						<div>
							{user.roles.map(
								(r, i) =>
									i !== user.roles.length - 1
										? r.display_name + ", "
										: r.display_name
							)}
						</div>
						<div className="thumbnail">
							{user.profile_photo_url ? (
								<img
									src={user.profile_photo_url}
									alt={user.first_name + " " + user.last_name}
								/>
							) : (
								<PlaceholderThumb
									firstName={user.first_name}
									lastName={user.last_name}
									size={24}
									contactDefaultPhoto={user.color}
								/>
							)}
						</div>
						<Col bottom-8>
							<div>{user.first_name + " " + user.last_name}</div>
							<small>{user.email}</small>
						</Col>
					</Col>
				</Row>
				<div>
					<NavLink to={`${match.path}/profile`}>
						<Row _no-grow-first>
							<div>
								<FaUser />
							</div>
							<div>Profile</div>
						</Row>
					</NavLink>
					<RenderIfUserHas roles={["admin"]}>
						<NavLink to={`${match.path}/user-management`}>
							<Row _no-grow-first>
								<div>
									<FaGroup />
								</div>
								<div>User Management</div>
							</Row>
						</NavLink>
					</RenderIfUserHas>
					{/* <RenderIfUserHas roles={['admin']}> */}
					<NavLink to={`${match.path}/projects`}>
						<Row _no-grow-first>
							<div>
								<FaTask />
							</div>
							<div>Projects</div>
						</Row>
					</NavLink>
					{/* </RenderIfUserHas> */}
					<RenderIfUserHas roles={["admin"]}>
						<NavLink to={`${match.path}/donors`}>
							<Row _no-grow-first>
								<div>
									<FaBlackTie />
								</div>
								<div>Donors</div>
							</Row>
						</NavLink>
					</RenderIfUserHas>
					{/* <RenderIfUserHas roles={["admin"]}> */}
					<NavLink to={`${match.path}/calendar`}>
						<Row _no-grow-first>
							<div>
								<FaCalendar />
							</div>
							<div>Calendar</div>
						</Row>
					</NavLink>
					{/* </RenderIfUserHas> */}
					<NavLink to={`${match.path}/timesheet`}>
						<Row _no-grow-first>
							<div>
								<FaClockO />
							</div>
							<div>Timesheet</div>
						</Row>
					</NavLink>
					<NavLink to={`${match.path}/files`}>
						<Row _no-grow-first>
							<div>
								<FaFileO />
							</div>
							<div>Files</div>
						</Row>
					</NavLink>
					<NavLink to={`${match.path}/gfa-documents`}>
						<Row _no-grow-first>
							<div>
								<FaFolderOpen />
							</div>
							<div>GFA Documents</div>
						</Row>
					</NavLink>
					<NavLink to={`${match.path}/letters`}>
						<Row _no-grow-first>
							<div>
								<FaFileText />
							</div>
							<div>Letters</div>
						</Row>
					</NavLink>
				</div>
				<Row _no-grow-first _no-align bottom>
					<div className="left-placeholder" />
					<Col _no-grow _bottom-8 sign-out>
						<div>
							<Button
								className="btn-green btn-stretch btn-darkBlue"
								onClick={this.onSignOutClick}
							>
								SIGN OUT
							</Button>
						</div>
						<small>Developed by BiznetX</small>
					</Col>
				</Row>
			</Col>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.auth.currentUser
	};
};

export default connect(
	mapStateToProps,
	{ signout }
)(SideBar);



// WEBPACK FOOTER //
// ./src/components/main/SideBar.js